import { de } from "date-fns/locale";
import { Button } from "primereact/button";
import { useState, useEffect, useRef } from "react";

const Step2 = ({
    step,
    setStep,
    selectedIllnessList,
    manuelSelectedExercises,
    setSelectedExercises,
    selectedPanels,
    setSelectedIllnessList,
    systemPanels,
    applyPanelsFilter,
    selectedFiguresForFilter,
    applyButtonVisibleFirstStep,
    applyButtonVisible,
    setApplyButtonVisible,
    t }: any) => {

    const [listOfIllnesses, setListOfIllnesses] = useState<any>([]);
    const previousSelectedIllnessesRef = useRef<any[]>([]);

    const areIllnessesSame = (illnesses1: any[], illnesses2: any[]): boolean => {
        if (illnesses1.length !== illnesses2.length) return false;
        const ids1 = new Set([...illnesses1].sort());
        const ids2 = new Set([...illnesses2].sort());
        if (ids1.size !== ids2.size) return false;
        for (const id of ids1) {
            if (!ids2.has(id)) return false;
        }
        return true;
    };

    useEffect(() => {
        if (systemPanels && selectedFiguresForFilter.length > 0) {
            const allIllnesses: string[] = [];
            const filteredPanels = systemPanels.filter((panel: any) => {
                if (selectedFiguresForFilter.length === 0) {
                    return true;
                }
                return panel.bodyParts?.some((bp: string) =>
                    selectedFiguresForFilter.includes(bp)
                );
            });

            filteredPanels.forEach((panel: any) => {
                if (panel.illnesses) {
                    panel.illnesses.forEach((illness: string) => {
                        if (illness) {
                            allIllnesses.push(illness);
                        }
                    });
                }
            });
            const uniqueIllnesses = Array.from(new Set(allIllnesses));
            setListOfIllnesses(uniqueIllnesses);

            setSelectedIllnessList((prev: any) => {
                return prev.filter((illness: any) => uniqueIllnesses.includes(illness));
            });
        }
    }, [systemPanels, selectedFiguresForFilter]);

    useEffect(() => {
        if (step === 2) {
            if ((selectedPanels.length !== 0 || manuelSelectedExercises.length !== 0) && previousSelectedIllnessesRef.current.length > 0) {
                const illnessesAreSame = areIllnessesSame(selectedIllnessList, previousSelectedIllnessesRef.current);
                if (illnessesAreSame) {
                    setApplyButtonVisible(false);
                } else {
                    setApplyButtonVisible(true);
                }
            } else {
                setApplyButtonVisible(true);
            }
        }
    }, [selectedIllnessList, selectedPanels, step]);

    return (
        <div
            style={{
                flex: step === 2 ? "0 0 41.666667%" : step === 4 ? "0 1 12%" : "1 1 0%",
                backgroundColor: step === 2 ? "#D4DDFF" : "#E8EDFF",
                borderRadius: "16px",
                padding: "1.5rem",
                height: "100%",
                overflow: "hidden",
                position: "relative",
                cursor: (step === 3 || step === 4 || (step === 1 && selectedIllnessList.length !== 0 && !applyButtonVisibleFirstStep)) ? "pointer" : "default",
                display: "flex",
                flexDirection: "column",
                transition: "flex 0.4s ease-in-out, background-color 0.4s ease-in-out",
                minWidth: 0
            }}
            onClick={step === 3 || step === 4 || (step === 1 && selectedIllnessList.length !== 0 && !applyButtonVisibleFirstStep) ? () => {
                setStep(2);
                setSelectedExercises([]);
            } : undefined}>

            {(step === 1 && selectedIllnessList.length === 0) &&
                <div className="w-full h-full flex flex-column gap-4 justify-content-center align-items-center">
                    <img src="/infoIcon2.svg" />
                    <div className="flex flex-column justify-content-center align-items-center">
                        <p className="m-0 font-bold text-xl " style={{ color: "#2D3967" }}>{t("illness")}</p>
                        <p className="m-0 text-sm" style={{ color: "#727A99" }}>{t("illnessDescription")}</p>
                    </div>

                </div>
            }

            <div className="flex flex-column" style={{ flex: 1, minHeight: 0, overflow: "auto" }}>
                {step === 2 && <p className="m-0 font-bold text-xl mb-5" style={{ color: "#2D3967" }}>{t("selectTheIllness")}</p>}
                {(step !== 2 && selectedIllnessList.length !== 0) && <p className="m-0 font-bold text-xl mb-5" style={{ color: "#2D3967" }}>{t("illness")}</p>}

                {step === 2 && listOfIllnesses.length === 0 && (
                    <p className="m-0 text-sm" style={{ color: "#727A99" }}>
                        {t("noIllnessesForThisArea")}
                    </p>
                )}

                <div className="flex flex-column gap-3 w-full"
                    style={{ cursor: (step === 2 || step === 3 || step === 4 || (step === 1 && selectedIllnessList.length !== 0 && !applyButtonVisibleFirstStep)) ? "pointer" : "default" }}>
                    {listOfIllnesses.map((illness: any) => (
                        <div className="p-3 w-full" style={{
                            backgroundColor: selectedIllnessList.includes(illness) ? "#2D3967" : "#F4F6FC",
                            color: selectedIllnessList.includes(illness) ? "#FFFFFF" : "#2D3967",
                            borderRadius: "16px"
                        }}
                            onClick={() => {
                                if (step === 2) {
                                    setSelectedIllnessList((prev: any) => {
                                        if (prev.includes(illness)) {
                                            return prev.filter((selected: any) => selected !== illness);
                                        } else {
                                            return [...prev, illness];
                                        }
                                    });
                                }
                            }}>
                            <p className="m-0 text-sm" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{illness}</p>
                        </div>
                    ))}
                </div>
            </div>

            {step === 2 &&
                <div className="flex justify-content-between align-items-center" style={{
                    backgroundColor: "#D4DDFF",
                    paddingTop: "1rem",
                    marginTop: "auto",
                    flexShrink: 0
                }}>
                    <div className="flex align-items-center justify-content-center  gap-2" style={{ cursor: "pointer" }}
                        onClick={() => {
                            setSelectedIllnessList([]);
                            previousSelectedIllnessesRef.current = [];
                            setApplyButtonVisible(true);
                        }}>
                        <i className="pi pi-trash" style={{ color: "#727A99" }}></i>
                        <p className="m-0 text-sm underline" style={{ color: "#727A99" }}>{t("clearChoice")}</p>
                    </div>

                    {applyButtonVisible &&
                        <Button label={t("apply")} className="p-3"
                            style={{ backgroundColor: "#6383F4", color: "#FFFFFF", borderRadius: "16px", border: "none", width: "6rem", height: "2.5rem" }}
                            onClick={() => {
                                if (selectedIllnessList.length > 0) {
                                    previousSelectedIllnessesRef.current = [...selectedIllnessList];
                                    applyPanelsFilter();
                                    setStep(3);
                                }
                            }}
                            disabled={selectedIllnessList.length === 0}
                        />}
                </div>
            }
        </div>
    )
}

export default Step2;